export const GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX = "[GenogramExport]"

export const PNG_COLOR_TYPE_RGBA = 6
export const PNG_BIT_DEPTH_8 = 8
export const PNG_COMPRESSION_METHOD_DEFLATE = 0
export const PNG_FILTER_METHOD_STANDARD = 0
export const PNG_INTERLACE_NONE = 0
export const PNG_FILTER_TYPE_NONE = 0
export const PNG_DEFAULT_IDAT_CHUNK_SIZE = 64 * 1024

export const DEFAULT_EXPORT_TILE_SIZE = 2048
export const DEFAULT_EXPORT_STRIPE_HEIGHT = 128
export const PDF_TILED_EXPORT_MAX_LONG_SIDE_PX = 5000
export const PDF_TILED_EXPORT_MAX_TOTAL_PIXELS = 16000000
